import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconArrowDownOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m11.25 21.129-8.266-8.266a.75.75 0 0 0-1.06 1.06L12 24l10.076-10.076a.75.75 0 0 0-1.06-1.06l-8.266 8.265V.75a.75.75 0 0 0-1.5 0z" /></svg>
);
